import { useState } from 'react';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Tabs as TabsComponent, Tab } from '@optimus-web/core';
import { TabItem } from './tabItem';

export interface WithActiveTabValue {
    activeTabValue: string;
}

interface TabsProps {
    children: (props: WithActiveTabValue) => React.ReactNode;
    isAfterStartTabVisible: boolean;
}

export const Tabs: React.FC<TabsProps> = ({ children, isAfterStartTabVisible }) => {
    const [activeTabValue, setActiveTabValue] = useState<string>(TabItem.General);

    const handleTabClick = (_: React.MouseEvent<HTMLElement>, value: string) => {
        setActiveTabValue(value);
    };

    return (
        <>
            <TabsComponent inline activeTabValue={activeTabValue} onTabClick={handleTabClick}>
                <Tab
                    id={TabItem.General}
                    key={TabItem.General}
                    value={TabItem.General}
                    label={<LocalizedText textKey={TextKey.General} />}
                />
                <Tab
                    id={TabItem.OnlineCheckIn}
                    key={TabItem.OnlineCheckIn}
                    value={TabItem.OnlineCheckIn}
                    label={<LocalizedText textKey={TextKey.OnlineCheckIn} />}
                />
                {isAfterStartTabVisible ? (
                    <Tab
                        id={TabItem.AfterStart}
                        key={TabItem.AfterStart}
                        value={TabItem.AfterStart}
                        label={<LocalizedText textKey={TextKey.AfterStartTabName} />}
                    />
                ) : (
                    <></>
                )}
            </TabsComponent>
            {children({ activeTabValue })}
        </>
    );
};
